<script setup>
  import { useOfferStore } from '../../stores/OfferStore';

  const offerStore = useOfferStore();
  const props = defineProps({
    offer_id: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    }
  });

  const updateQuantity = (event) => {
    offerStore.updateQuantity(props.offer_id, event.target.value);
  }

  const scrollQuantity = (event) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      const currentValue = parseInt(event.target.value) || 0;
      const newValue = event.key === 'ArrowUp' ? currentValue + 1 : Math.max(currentValue - 1, 0);
      event.target.value = newValue;
      offerStore.updateQuantity(props.offer_id, newValue);
    }
  }
</script>

<template>
  <input type="text" @input="updateQuantity($event)" @keyup="scrollQuantity($event)" :value="quantity" class="cart-item__quantity-box-input" :data-value="quantity" :data-default-value="quantity" role="spinbutton" :aria-valuenow="quantity" aria-valuemin="0" />
</template>
